import * as Yup from 'yup';

export const editDetailsTabSchema = () => {
  return Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .min(1, 'Name is required')
      .max(50, 'Name should have maximum 50 characters'),
    vat_number: Yup.string()
      .required('VAT number is required')
      .min(1, 'VAT number is required')
      .max(50, 'VAT number should have maximum 50 characters'),
    coc_number: Yup.string()
      .required('COC number is required')
      .min(1, 'COC number is required')
      .max(50, 'COC number should have maximum 50 characters'),
    website: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable()
      .url('Please enter a valid URL')
      .max(100, 'Website should have maximum 100 characters'),
    email: Yup.string()
      .email('Invalid E-mail')
      .required('E-mail is required')
      .min(1, 'E-mail is required')
      .max(250, 'Email should have maximum 250 characters'),
    phone_number: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable()
      .max(50, 'Phone number should have maximum 50 characters'),
  });
};

export const editAddressTabSchema = () => {
  return Yup.object().shape({
    street: Yup.string().required('Street is required'),
    house_number: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable(),
    zip_code: Yup.string().required('Zip code is required'),
    city: Yup.string().required('City is required'),
    country: Yup.string()
      .required('Country is required')
      .length(2, 'Country code must be exactly 2 characters'),
  });
};
